/**
 * created by xcc
 * 下发提醒
 */
import React from "react";
import {Modal, Button, Radio, Form, Icon} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import Scrollbars from 'react-custom-scrollbars';
import {message} from "../../../../utils/message";
import {formatTime} from "../../../../utils";

export default class SendRemind extends BaseComponent {
    static defaultProps = {
        viewAll: false,
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            remindType: 1,
            remindInfo: {}
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    sendRemind = (remindType) => {
        this.setState({
            visible: true,
            remindType
        }, () => {
            this.findMessage()
        })
    }

    findMessage = () => {
        const {positionId} = this.props;
        this.request({
            url: "/cm-sites-media-consumer/position/management/findPositionMessage",
            method: "post",
            body: {
                id: positionId,
                type: this.state.remindType
            },
            callBack: (data) => {
                this.setState({
                    remindInfo: data || {},
                })

            },
            errorCallBack: () => {
            },
            serverVerify: {
                serverErrorCallBack: () => {
                }
            }
        })
    }

    renderFooter = () => {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Button onClick={() => this.setState({visible: false})}>关闭</Button>
                <Button type={"primary"} onClick={() => {
                    this.onOk();
                }}>确定下发</Button>
            </div>
        )
    }

    onOk = () => {
        const {positionId} = this.props;
        this.request({
            url: "/cm-sites-media-consumer/position/management/sendPositionMessage",
            method: "post",
            body: {
                id: positionId,
                type: this.state.remindType
            },
            callBack: (data) => {
                if (data) {
                    message.success("下发成功");
                    this.setState({
                        visible: false,
                    })
                } else {
                    message.warn("下发失败");
                }
            },
            errorCallBack: () => {
            },
            serverVerify: {}
        })
    }

    onChange = (e) => {
        this.setState({
            remindType: e.target.value,
        }, () => {
            this.sendRemind(this.state.remindType)
        });
    }

    render() {
        let {remindType, remindInfo} = this.state;
        const {btnStyle = {}} = this.props;
        return (
            <>
                <Button style={{...btnStyle}} onClick={() => this.sendRemind(1)}>下发提醒</Button>
                <Modal
                    title={"下发提醒"}
                    visible={this.state.visible}
                    onCancel={() => {
                        this.setState({
                            visible: false,
                        })
                    }}
                    width={600}
                    footer={this.renderFooter()}
                    destroyOnClose={true}
                    centered={true}
                    maskClosable={false}
                >
                    <Scrollbars autoHide autoHeight autoHeightMax={600}>
                        <Form
                            className='remind-content'
                            style={{display: "flex", flexDirection: "column"}}
                            layout="horizontal"
                            labelCol={{span: 3}}
                            labelAlign='left'
                            wrapperCol={{span: 21}}
                        >
                            <Form.Item
                                label="提醒类型"
                            >
                                <Radio.Group value={remindType} onChange={this.onChange}>
                                    <Radio.Button value={1}>年审提醒</Radio.Button>
                                    <Radio.Button value={2}>注销提醒</Radio.Button>
                                </Radio.Group>
                                <div style={{marginBottom: 20}}>
                                    <Icon style={{verticalAlign: "middle", color: "#1890ff"}}
                                          type="question-circle"/><span style={{
                                    color: "#ff000d",
                                    marginLeft: 5
                                }}>向账号创建人下发提醒，创建人可通过消息通知接收提醒并查看。</span>
                                </div>
                                <div style={{lineHeight: "24px"}}>
                                    <div>最新提醒时间：<span style={{fontWeight: 500}}>{remindInfo?.publishTime ? formatTime(remindInfo?.publishTime) : "无"}</span></div>
                                    <div>最新提醒操作人：<span style={{fontWeight: 500}}>{remindInfo?.createByName || "无"}</span></div>
                                </div>
                            </Form.Item>
                        </Form>
                    </Scrollbars>
                </Modal>
            </>
        );
    }
}